import { createRef, useEffect, useRef, useState } from "react";
import { ColorPicker, Image, FontIcon, getColorFromString, IColor, IColorPickerStyles, IconButton, Label, PrimaryButton, Stack, TextField, ImageFit, Checkbox, ChoiceGroup } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { TConfig, TLoginState } from "../constants/types";
import cookie from 'react-cookies';
import React from "react";
import styles from "../styles/admin.module.scss";
import CountTag from "./countTag";

export interface IStylingProps {
    token: string;
    username: string;
    site: string;
    apiUrl: string;
    setMessage: Function;
    setError: Function;
}

const colorPickerStyles: Partial<IColorPickerStyles> = {
    panel: { padding: 12 },
    root: {
        minWidth: 200,
    },
    table: {
        display: "none"
    },
    flexPreviewBox: {
        display: "none"
    },

    colorRectangle: { height: 200 },
};

const Styling: React.FunctionComponent<IStylingProps> = (props: IStylingProps) => {
    const [bannerColor, setBannerColor] = useState<IColor>();
    const [setColor, setSetColor] = useState<IColor>();
    const [setMenuColor, setSetMenuColor] = useState<IColor>();

    const [newBannerImgFile, setNewBannerImgFile] = useState<File>();
    const [newBannerBGFile, setNewBannerBGFile] = useState<File>();
    const [newSetImgFile, setNewSetImgFile] = useState<File>();
    const bannerImgUrl = `https://${props.site}.nl/assets/sitebanner.png?v=${Date.now()}`;

    const bannerInputRef = React.useRef<HTMLInputElement>(null);
    const bannerBGRef = React.useRef<HTMLInputElement>(null);
    const setInputRef = React.useRef<HTMLInputElement>(null);
    const setBGRef = React.useRef<HTMLInputElement>(null);
    const footerBGRef = React.useRef<HTMLInputElement>(null);

    let setcount = Math.floor(window.innerWidth / 500);
    if (setcount === 0) setcount = 1;
    const setcountmapper = new Array(setcount);

    const [BANNER_COLOR, setBANNER_COLOR] = useState<TConfig>();
    const [SET_COLOR, setSET_COLOR] = useState<TConfig>();
    const [SET_MENU_COLOR, setSET_MENU_COLOR] = useState<TConfig>();
    const [setBGFile, setsetBGFile] = useState<File>();
    const [footerBGFile, setfooterBGFile] = useState<File>();

    const [bgColor, setBGColor] = useState<IColor>();
    const [BGCOLOR, setBGCOLOR] = useState<TConfig>();

    const [FOOTERHEADERBGCOLOR, setFOOTERHEADERBGCOLOR] = useState<TConfig>();
    const [footerheaderbgcolor, setfooterheaderbgcolor] = useState<IColor>();

    const [FOOTERHEADERFONTCOLOR, setFOOTERHEADERFONTCOLOR] = useState<TConfig>();
    const [footerheaderfontcolor, setfooterheaderfontcolor] = useState<IColor>();

    const [SHOWSETCOUNTTAG, setSHOWSETCOUNTTAG] = useState<TConfig>();
    const [SETCOUNTTAGLOCATION, setSETCOUNTTAGLOCATION] = useState<TConfig>()
    const [showCountTag, setshowCountTag] = useState<boolean>();
    const [countTagLeft, setcountTagLeft] = useState<boolean>();
    const [countTagBottom, setcountTagBottom] = useState<boolean>();

    for (let i = 0; i < setcount; i++) {
        setcountmapper[i] = "ASDF";
    }

    useEffect(() => {
        fetch(`${props.apiUrl}/GetConfig?username=${props.username}&token=${props.token}&site=${props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data: TConfig[]) => {
            data.forEach((d) => {
                switch (d.name) {
                    case "SHOWSETCOUNTTAG":
                        setSHOWSETCOUNTTAG(d);
                        setshowCountTag(d.value === "1" ? true : false);
                        break;
                    case "SETCOUNTTAGLOCATION":
                        setSETCOUNTTAGLOCATION(d);
                        setTagLocation(d.value);
                        break;
                    case "FOOTERHEADERFONTCOLOR":
                        setFOOTERHEADERFONTCOLOR(d);
                        setfooterheaderfontcolor(getColorFromString(d.value));
                        break;
                    case "FOOTERHEADERBGCOLOR":
                        setFOOTERHEADERBGCOLOR(d);
                        setfooterheaderbgcolor(getColorFromString(d.value));
                        break;
                    case "BGCOLOR":
                        setBGCOLOR(d);
                        setBGColor(getColorFromString(d.value));
                        break;
                    case "SET_COLOR":
                        setSET_COLOR(d);
                        setSetColor(getColorFromString(d.value));
                        break;
                    case "SET_MENU_COLOR":
                        setSET_MENU_COLOR(d);
                        setSetMenuColor(getColorFromString(d.value));
                        break;
                    case "BANNER_COLOR":
                        setBANNER_COLOR(d);
                        setBannerColor(getColorFromString(d.value));
                        break;
                    default:
                        break;
                }
            })
        }).catch(err => {
            console.log(err);
        });

        window.scrollTo(0, 0);
    }, []);

    function setTagLocation(value: string) {
        let left : boolean = false;
        let bottom : boolean = false;
        if (value.length === 2) {
            if (value[0] === "L") {
                left = true;
            }
            if (value[1] === "B") {
                bottom = true;
            }
        } 
        setcountTagLeft(left);
        setcountTagBottom(bottom);
    }

    function getTagLocation(left: boolean, bottom: boolean) : string {
        let locstring = "";
        if (left) {
            locstring += "L";
        } else {
            locstring += "R";
        }
        if (bottom) {
            locstring += "B";
        } else {
            locstring += "T";
        }
        return locstring;
    }

    function saveAssetFile(f: File, name: string) {
        let formData = new FormData();
        const nameparts = f.name.split('.');
        const extention = nameparts[nameparts.length - 1];
        formData.append(name + "." + extention, f);
        formData.append("site", props.site);
        formData.append("token", props.token);
        formData.append("username", props.username);

        fetch(`${props.apiUrl}/SetAssets`, {
            method: "Put",
            mode: "cors",
            referrerPolicy: "origin-when-cross-origin",
            body: formData
        }).then((response) => response.json()).then((data: boolean) => {
            console.log(data);
            if (data === false) {
                this.props.setError("Banner is niet geupload.");
            }
            props.setMessage("Nieuwe banner successvol toegevoegd.");
        }).catch(err => {
            this.props.setError(err);
        });
    }

    function save() {
        let newConfigs: TConfig[] = [];

        if (newBannerImgFile) {
            saveAssetFile(newBannerImgFile, "sitebanner");
        }
        if (newBannerBGFile) {
            saveAssetFile(newBannerBGFile, "container_bg");
        }
        if (setBGFile) {
            saveAssetFile(setBGFile, "container_set_bg");
        }
        if (footerBGFile) {
            saveAssetFile(setBGFile, "container_footer_bg");
        }

        if (bannerColor.str !== BANNER_COLOR.value) {
            newConfigs.push({ id: BANNER_COLOR.id, name: BANNER_COLOR.name, value: bannerColor.str });
        }
        if (setColor.str !== SET_COLOR.value) {
            newConfigs.push({ id: SET_COLOR.id, name: SET_COLOR.name, value: setColor.str });
        }
        if (setMenuColor.str !== SET_MENU_COLOR.value) {
            newConfigs.push({ id: SET_MENU_COLOR.id, name: SET_MENU_COLOR.name, value: setMenuColor.str });
        }
        if (bgColor.str !== BGCOLOR.value) {
            newConfigs.push({ id: BGCOLOR.id, name: BGCOLOR.name, value: bgColor.str });
        }
        if (footerheaderbgcolor.str !== FOOTERHEADERBGCOLOR.value) {
            newConfigs.push({ id: FOOTERHEADERBGCOLOR.id, name: FOOTERHEADERBGCOLOR.name, value: footerheaderbgcolor.str });
        }
        if (footerheaderfontcolor.str !== FOOTERHEADERFONTCOLOR.value) {
            newConfigs.push({ id: FOOTERHEADERFONTCOLOR.id, name: FOOTERHEADERFONTCOLOR.name, value: footerheaderfontcolor.str });
        }
        if (SHOWSETCOUNTTAG.value ? true : false !==  showCountTag) {
            newConfigs.push({ id: SHOWSETCOUNTTAG.id, name: SHOWSETCOUNTTAG.name, value: showCountTag ? "1" : "0"});
        }
        if (SETCOUNTTAGLOCATION.value != getTagLocation(countTagLeft, countTagBottom)) {
            newConfigs.push({ id: SETCOUNTTAGLOCATION.id, name: SETCOUNTTAGLOCATION.name, value: getTagLocation(countTagLeft, countTagBottom)});
        }

        if (newConfigs.length) {
            fetch(`${props.apiUrl}/SetConfig`, {
                method: "Post",
                mode: "cors",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Accept-Encoding": "gzip, deflate ,br"
                },
                referrerPolicy: "origin-when-cross-origin",
                body: JSON.stringify({ token: props.token, username: props.username, site: props.site, items: newConfigs }),
            }).then((response) => response.json()).then((data) => data).then((success: boolean) => {
                if (success) {
                    setBANNER_COLOR({ id: BANNER_COLOR.id, name: BANNER_COLOR.name, value: bannerColor.str });
                    setSET_COLOR({ id: SET_COLOR.id, name: SET_COLOR.name, value: setColor.str });
                    setSET_MENU_COLOR({ id: SET_MENU_COLOR.id, name: SET_MENU_COLOR.name, value: setMenuColor.str });
                    setFOOTERHEADERBGCOLOR({ id: FOOTERHEADERBGCOLOR.id, name: FOOTERHEADERBGCOLOR.name, value: footerheaderbgcolor.str });
                    setFOOTERHEADERFONTCOLOR({ id: FOOTERHEADERFONTCOLOR.id, name: FOOTERHEADERFONTCOLOR.name, value: footerheaderfontcolor.str });
                    props.setMessage("Nieuwe styling opgeslagen.");
                } else {
                    props.setError("Opslag styling gefaald.");
                }
            }).catch((ex) => {
                props.setError(ex);
            });
        }
    }


    return (
        <Stack horizontalAlign="start" style={{ height: "100%", width: "100%", padding: 10, overflow: "hidden" }}>
            <hr />
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <Stack horizontal verticalAlign="center">
                    <h2 style={{ paddingLeft: 10, whiteSpace: "nowrap" }}>Site banner</h2>
                    <Stack horizontalAlign="end" verticalAlign="center" style={{ width: "100%", backgroundColor: "lightgreen" }}>
                        <div style={{ margin: 10 }}>
                            <PrimaryButton text="Opslaan in site" onClick={save} />
                        </div>
                    </Stack>
                </Stack>
            </Stack>
            <hr />
{/* Banner */}
            <Stack horizontal style={{ width: "100%", display:window.innerWidth > 950 ? "flex" : "block" }}>
                <Stack style={{ width: window.innerWidth > 950 ? "75%" : "100%", backgroundColor: bannerColor?.str ? bannerColor.str : "white", backgroundImage: newBannerBGFile !== undefined ? newBannerBGFile ? `url('${URL.createObjectURL(newBannerBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')` }} verticalAlign="center" horizontalAlign="center">
                    <img src={newBannerImgFile ? URL.createObjectURL(newBannerImgFile) : bannerImgUrl} style={{ cursor: "pointer", maxWidth: "50%" }} />
                    <Stack horizontal horizontalAlign="center" style={{ width: "100%" }}>
                        <PrimaryButton text="Upload nieuwe banner foto" onClick={() => { bannerInputRef.current.click(); }} />
                        <PrimaryButton disabled={newBannerImgFile ? false : true} style={{ marginLeft: 10 }} text="Reset" onClick={() => { setNewBannerImgFile(undefined); }} />
                        <input id="upload" multiple type="file" hidden ref={bannerInputRef} onChange={(e) => { setNewBannerImgFile(e.target.files[0]); }} />
                    </Stack>
                </Stack>
                <Stack horizontalAlign="end" style={{ width: window.innerWidth > 950 ? "15%" : "100%" }}>
                    <ColorPicker
                        color={bannerColor}
                        onChange={(ev: any, colorObj: IColor) => setBannerColor(colorObj)}
                        alphaType="none"
                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" style={{ marginRight: 10 }} onClick={() => { setBannerColor(getColorFromString(BANNER_COLOR.value)); }} />
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "10%" : "100%" }}>
                    <Label>Standaard achtergrond</Label>
                    <Stack onClick={() => { setNewBannerBGFile(undefined); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", backgroundImage: `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>

                    </Stack>
                    <Label>Geen achtergrond</Label>
                    <Stack onClick={() => { setNewBannerBGFile(null); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", border: "1px solid blue" }}>

                    </Stack>
                    <Label>Eigen achtergrond</Label>
                    <Stack horizontalAlign="center" verticalAlign="center" style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", backgroundImage: newBannerBGFile !== undefined ? newBannerBGFile ? `url('${URL.createObjectURL(newBannerBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>
                        <PrimaryButton text="Upload" onClick={() => { bannerBGRef.current.click(); }} />
                        <input id="upload" multiple type="file" hidden ref={bannerBGRef} onChange={(e) => { setNewBannerBGFile(e.target.files[0]); }} />
                    </Stack>
                </Stack>
            </Stack>

            <hr />
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <Stack horizontal verticalAlign="center">
                    <h2 style={{ paddingLeft: 10, whiteSpace: "nowrap" }}>Welkom pagina sets</h2>
                    <Stack horizontalAlign="end" verticalAlign="center" style={{ width: "100%", backgroundColor: "lightgreen" }}>
                        <div style={{ margin: 10 }}>
                            <PrimaryButton text="Opslaan in site" onClick={save} />
                        </div>
                    </Stack>
                </Stack>
            </Stack>
            <hr />
{/* Welkom pagina */}
            <Stack horizontal style={{ width: "100%", backgroundColor: bgColor?.str, display:window.innerWidth > 950 ? "flex" : "block" }}>
                <Stack style={{ margin: 10 }}>
                    <Stack horizontal>
                        {setcountmapper.map(() => {
                            return <Stack style={{margin:10}}>
                                       {showCountTag ? <CountTag count={9999} left={countTagLeft} bottom={countTagBottom} children={
                                                        <Stack style={{ width: "250", height: 250, maxWidth: 250, maxHeight: 250, backgroundColor: setColor?.str ? setColor.str : "white", backgroundImage: setBGFile !== undefined ? setBGFile ? `url('${URL.createObjectURL(setBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')` }} verticalAlign="center" horizontalAlign="center">
                                                            <img src={newSetImgFile ? URL.createObjectURL(newSetImgFile) : "https://pokemoncollectie.nl/assets/pokemon/220/220.webp"} style={{ cursor: "pointer", maxWidth: "100%" }} />
                                                        </Stack>
                                                       } /> 
                                                     : <Stack style={{ width: "250", height: 250, maxWidth: 250, maxHeight: 250, backgroundColor: setColor?.str ? setColor.str : "white", backgroundImage: setBGFile !== undefined ? setBGFile ? `url('${URL.createObjectURL(setBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')` }} verticalAlign="center" horizontalAlign="center">
                                                        <img src={newSetImgFile ? URL.createObjectURL(newSetImgFile) : "https://pokemoncollectie.nl/assets/pokemon/220/220.webp"} style={{ cursor: "pointer", maxWidth: "100%" }} />
                                                       </Stack>}
                                   </Stack>
                        })}
                    </Stack>
                    <Stack horizontal horizontalAlign="center" style={{ width: "100%" }}>
                        <PrimaryButton text="Upload test foto" onClick={() => { setInputRef.current.click(); }} />
                        <PrimaryButton disabled={newSetImgFile ? false : true} style={{ marginLeft: 10 }} text="Reset" onClick={() => { setNewSetImgFile(undefined); }} />
                        <input id="upload" multiple type="file" hidden ref={setInputRef} onChange={(e) => { setNewSetImgFile(e.target.files[0]); }} />
                    </Stack>
                </Stack>
                <Stack style={{ paddingTop: 10 }} verticalAlign="center">
                    {showCountTag !== undefined && <Checkbox label="Laat #nr label zien" checked={showCountTag} onChange={(e,c) => {setshowCountTag(c);}} />}
                    {countTagLeft !== undefined && countTagBottom !== undefined && <ChoiceGroup options={[{ key: 'RT', text: 'Rechts boven'}, 
                                           { key: 'RB', text: 'Rechts onder'}, 
                                           { key: 'LT', text: 'Links boven'}, 
                                           { key: 'LB', text: 'Links onder'}]}
                                 onChange={(e,o) => { setTagLocation(o.key); }}
                                 defaultSelectedKey={getTagLocation(countTagLeft, countTagBottom)} />}
                </Stack>
                <Stack>
                    <Label style={{ marginLeft: 10 }}>Achtergrond</Label>
                    <ColorPicker
                        color={bgColor}
                        onChange={(ev: any, colorObj: IColor) => setBGColor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setBGColor(getColorFromString(BGCOLOR.value)); }} />
                </Stack>
                <Stack style={{ marginLeft: 5 }}>
                    <Label style={{ marginLeft: 10 }}>Set overzicht</Label>
                    <ColorPicker
                        color={setColor}
                        onChange={(ev: any, colorObj: IColor) => setSetColor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setSetColor(getColorFromString(SET_COLOR.value)); }} />
                </Stack>
                <Stack style={{ marginLeft: 10 }}>
                    <Label>Standaard achtergrond</Label>
                    <Stack onClick={() => { setsetBGFile(undefined); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: setColor?.str ? setColor.str : "white", backgroundImage: `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>

                    </Stack>
                    <Label>Geen achtergrond</Label>
                    <Stack onClick={() => { setsetBGFile(null); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: setColor?.str ? setColor.str : "white", border: "1px solid blue" }}>

                    </Stack>
                    <Label>Eigen achtergrond</Label>
                    <Stack horizontalAlign="center" verticalAlign="center" style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: setColor?.str ? setColor.str : "white", backgroundImage: setBGFile !== undefined ? setBGFile ? `url('${URL.createObjectURL(setBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>
                        <PrimaryButton text="Upload" onClick={() => { setBGRef.current.click(); }} />
                        <input id="upload" multiple type="file" hidden ref={setBGRef} onChange={(e) => { setsetBGFile(e.target.files[0]); }} />
                    </Stack>
                </Stack>
            </Stack>

            <hr />
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <Stack horizontal verticalAlign="center">
                    <h2 style={{ paddingLeft: 10, whiteSpace: "nowrap" }}>Producten pagina</h2>
                    <Stack horizontalAlign="end" verticalAlign="center" style={{ width: "100%", backgroundColor: "lightgreen" }}>
                        <div style={{ margin: 10 }}>
                            <PrimaryButton text="Opslaan in site" onClick={save} />
                        </div>
                    </Stack>
                </Stack>
            </Stack>
            <hr />
{/* Producten pagina */}
            <Stack horizontal style={{ width: "100%", backgroundColor: bgColor?.str, display:window.innerWidth > 950 ? "flex" : "block" }}>
                <Stack style={{ width: window.innerWidth > 950 ? "65%" : "100%" }}>
                    <Stack>
                        <Stack style={{ margin: 12, width: "200", height: 100, maxWidth: 200, maxHeight: 100, backgroundColor: setMenuColor?.str ? setMenuColor.str : "white" }} verticalAlign="center" horizontalAlign="center">
                            <img src={newSetImgFile ? URL.createObjectURL(newSetImgFile) : "https://pokemoncollectie.nl/assets/pokemon/220/220.webp"} style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "100%" }} />
                        </Stack>
                        <Stack style={{ margin: 12, width: "200", height: 100, maxWidth: 200, maxHeight: 100, backgroundColor: setMenuColor?.str ? setMenuColor.str : "white" }} verticalAlign="center" horizontalAlign="center">
                            <img src={newSetImgFile ? URL.createObjectURL(newSetImgFile) : "https://pokemoncollectie.nl/assets/pokemon/220/220.webp"} style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "100%" }} />
                        </Stack>
                        <Stack style={{ margin: 12, width: "200", height: 100, maxWidth: 200, maxHeight: 100, backgroundColor: setMenuColor?.str ? setMenuColor.str : "white" }} verticalAlign="center" horizontalAlign="center">
                            <img src={newSetImgFile ? URL.createObjectURL(newSetImgFile) : "https://pokemoncollectie.nl/assets/pokemon/220/220.webp"} style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "100%" }} />
                        </Stack>
                    </Stack>
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "15%" : "100%" }}>
                    <Label>Achtergrond</Label>
                    <ColorPicker
                        color={bgColor}
                        onChange={(ev: any, colorObj: IColor) => setBGColor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setBGColor(getColorFromString(BGCOLOR.value)); }} />
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "15%" : "100%", marginLeft: 5 }}>
                    <Label>Set menu</Label>
                    <ColorPicker
                        color={setMenuColor}
                        onChange={(ev: any, colorObj: IColor) => setSetMenuColor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setSetMenuColor(getColorFromString(SET_MENU_COLOR.value)); }} />
                </Stack>
            </Stack>

            <hr />
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <Stack horizontal verticalAlign="center">
                    <h2 style={{ paddingLeft: 10, whiteSpace: "nowrap" }}>Header & Footer</h2>
                    <Stack horizontalAlign="end" verticalAlign="center" style={{ width: "100%", backgroundColor: "lightgreen" }}>
                        <div style={{ margin: 10 }}>
                            <PrimaryButton text="Opslaan in site" onClick={save} />
                        </div>
                    </Stack>
                </Stack>
            </Stack>
            <hr />
{/* Header Footer */}
            <Stack horizontal style={{ width: "100%", backgroundColor: bgColor?.str, paddingBottom: 10, display:window.innerWidth > 950 ? "flex" : "block" }}>
                <Stack style={{ width: window.innerWidth > 950 ? "65%" : "100%" }} horizontalAlign="center" verticalAlign="center">
                    <Stack horizontal style={{ width: window.innerWidth > 950 ? "90%" : "100%", borderBottomLeftRadius: 7, borderBottomRightRadius: 7, backgroundColor: footerheaderbgcolor?.str }} horizontalAlign='center'>
                        <Stack verticalAlign='center' style={{ paddingLeft: 5 }}>
                            <IconButton iconProps={{ iconName: 'Settings' }}
                                styles={{
                                    icon: { color: footerheaderfontcolor?.str, fontSize: 18 },
                                    root: {
                                        width: 18,
                                        height: "auto",
                                        margin: 2,
                                        padding: 2,
                                    }
                                }} />
                            <span style={{ fontSize: "xx-small", padding: "0px", paddingLeft: "2px", margin: "0px", color: footerheaderfontcolor?.str }}>Filter</span>
                        </Stack>
                        <div style={{ width: "100%", maxWidth: 600, verticalAlign: "middle", display: "inline-block" }}>
                            <Stack horizontal style={{ width: "100%" }}>
                                <TextField type="Search"
                                    className={styles.searchBox}
                                    autoFocus={true}
                                    iconProps={{
                                        iconName: 'search',
                                    }}
                                    style={{ width: "100%", maxWidth: 600, color: footerheaderfontcolor?.str }}
                                    placeholder={"Dummy text"} />
                            </Stack>
                        </div>
                        <Stack horizontalAlign='center'>
                            <FontIcon aria-label="Email" iconName="GlobalNavButton" style={{ color: footerheaderfontcolor?.str, fontSize: "x-large", fontWeight: 700, cursor: "pointer" }} />
                            <span style={{ fontSize: "xx-small", padding: "0px", margin: "0px", marginTop: "-5px", color: footerheaderfontcolor?.str }}>Menu</span>
                        </Stack>
                    </Stack>
                    <br />
                    <Stack horizontalAlign="center" style={{ width: "100%" }}>
                        <div className={styles.footerMain} style={{ width: window.innerWidth > 950 ? "90%" : "100%", backgroundImage: footerBGFile !== undefined ? footerBGFile ? `url('${URL.createObjectURL(footerBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')` }}>
                            <Stack horizontal horizontalAlign='center' style={{ backgroundColor: footerheaderbgcolor?.str, borderTopLeftRadius: 7, borderTopRightRadius: 7, width: "100%" }}>
                                <div style={{ display: "table" }}>
                                    <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                                        <div>
                                            <Label style={{ color: footerheaderfontcolor?.str }}>FOOTER_TEXT - Contact : </Label>
                                        </div>
                                    </div>
                                </div>
                                <a href={`mailto:test@test.nu`} >
                                    <FontIcon aria-label="Email" iconName="mail" style={{ cursor: "pointer", fontSize: 30, color: footerheaderfontcolor?.str }}
                                        onClick={() => { window.open(`mailto:test@test.nl`); }} />
                                </a>
                                <Image style={{ maxWidth: 40, cursor: "pointer", color: footerheaderfontcolor?.str }}
                                    src={`https://${props.site}.nl/assets/whatsapp2.webp`}
                                    alt="" imageFit={ImageFit.contain} />
                            </Stack>
                            <Stack horizontal>
                                <Stack style={{ whiteSpace: "nowrap", minWidth: "40%", paddingLeft: 20 }} >
                                    <span style={{ color: "gray", fontSize: "large" }}>Informatie</span>
                                    <span style={{ cursor: "pointer", fontSize: "smaller", color: "darkgray" }} onClick={() => { }}>Privacybeleid</span>
                                    <span style={{ cursor: "pointer", fontSize: "smaller", color: "darkgray" }} onClick={() => { }}>Retourbeleid</span>
                                    <span style={{ cursor: "pointer", fontSize: "smaller", color: "darkgray" }} onClick={() => { }}>Over Ons</span>
                                </Stack>
                            </Stack>
                        </div>
                    </Stack>
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "15%" : "100%" }}>
                    <Label>Header/Footer tekst kleur</Label>
                    <ColorPicker
                        color={footerheaderfontcolor}
                        onChange={(ev: any, colorObj: IColor) => setfooterheaderfontcolor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setfooterheaderfontcolor(getColorFromString(FOOTERHEADERFONTCOLOR.value)); }} />
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "15%" : "100%", marginLeft: 5 }}>
                    <Label>Header/Footer achtergrond kleur</Label>
                    <ColorPicker
                        color={footerheaderbgcolor}
                        onChange={(ev: any, colorObj: IColor) => setfooterheaderbgcolor(colorObj)}

                        styles={colorPickerStyles}
                        strings={{
                            hueAriaLabel: 'Hue',
                        }}
                    />
                    <PrimaryButton text="Reset" onClick={() => { setfooterheaderbgcolor(getColorFromString(FOOTERHEADERBGCOLOR.value)); }} />
                </Stack>
                <Stack style={{ width: window.innerWidth > 950 ? "10%" : "100%" }}>
                    <Label>Standaard achtergrond</Label>
                    <Stack onClick={() => { setfooterBGFile(undefined); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", backgroundImage: `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>

                    </Stack>
                    <Label>Geen achtergrond</Label>
                    <Stack onClick={() => { setfooterBGFile(null); }} style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", border: "1px solid blue" }}>

                    </Stack>
                    <Label>Eigen achtergrond</Label>
                    <Stack horizontalAlign="center" verticalAlign="center" style={{ cursor: "pointer", height: "30%", minHeight:100, backgroundColor: bannerColor?.str ? bannerColor.str : "white", backgroundImage: footerBGFile !== undefined ? footerBGFile ? `url('${URL.createObjectURL(footerBGFile)}')` : "" : `url('https://${props.site}.nl/assets/backgrounds/1.webp')`, border: "1px solid blue" }}>
                        <PrimaryButton text="Upload" onClick={() => { footerBGRef.current.click(); }} />
                        <input id="upload" multiple type="file" hidden ref={footerBGRef} onChange={(e) => { setfooterBGFile(e.target.files[0]); }} />
                    </Stack>
                </Stack>
            </Stack>
{/* save */}
            <hr />
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <Stack horizontal verticalAlign="center">
                    <h2 style={{ paddingLeft: 10, whiteSpace: "nowrap" }}>Save</h2>
                    <Stack horizontalAlign="end" verticalAlign="center" style={{ width: "100%", backgroundColor: "lightgreen" }}>
                        <div style={{ margin: 10 }}>
                            <PrimaryButton text="Opslaan in site" onClick={save} />
                        </div>
                    </Stack>
                </Stack>
            </Stack>
            <hr />

        </Stack>
    );
}

export default Styling;